import { SchemaContext } from 'contexts/SchemaContext';
import { SchemaReducer } from 'contexts/SchemaContext/SchemaReducer';
import type { FC } from 'react';
import { useReducer } from 'react';
import type { IContainerChildrenProps } from 'utils';
import { SchemaContextHelper } from './SchemaContextHelper';

const SchemaProvider: FC<IContainerChildrenProps> = ({ children }) => {
  const [state, dispatch] = useReducer(SchemaReducer, {
    schema: { _meta: { type: 'dict' } },
    name: '',
    selectedField: null,
    addFieldOverlay: false,
    locked: false
  });
  const helper = new SchemaContextHelper(state);

  // eslint-disable-next-line react/jsx-no-constructed-context-values
  return <SchemaContext.Provider value={{ state, dispatch, helper }}>{children}</SchemaContext.Provider>;
};

export default SchemaProvider;
